import axios, { AxiosResponse } from 'axios'
import { slides } from '@bt-react/constants'
import apiGateway from '../apiGateway'
import { SlidesDeckVersion } from '../../components/SlidesScreen/types'

const getSlidesUploadUrl = (talkId, fileName) => axios.post(`${apiGateway.getBasePath()}/s3/ui-auth/${talkId}/generate-slide-upload-link`, {
  'talkId': talkId,
  'fileName': fileName
}, { withCredentials: true })

export default {

  removeSlides: (talkId, slidesId) => {

    return new Promise((resolve, reject) => {

      axios.delete(`${apiGateway.getBasePath()}/twilio/ui-auth/${talkId}/slides/${slidesId}`, { withCredentials: true })
        .then(resolve)
        .catch(reject)

    })

  },
  setFeatureImage: (talkId, slidesId) => {

    return axios.post(`${apiGateway.getBasePath()}/slidemanager/ui-auth/${talkId}/${slidesId}/set-slides-as-feature-image`, null, { withCredentials: true })

  },
  uploadSlides: (talkId, slidesFile, onUploadProgress) => {

    return new Promise(async (resolve, reject) => {

      const { data } = await getSlidesUploadUrl(talkId, slidesFile.name)
      if (data && data.uploadUrl) {

        try {

          const cancelToken = await axios.CancelToken.source()
          axios.put(data.uploadUrl, slidesFile, {
            onUploadProgress: ({ loaded, total }) => {

              onUploadProgress({ loaded, total, cancelToken: cancelToken })

            },
            cancelToken: cancelToken.token,
            headers: {
              'Content-Type': slidesFile.type
            }
          })
            .then(() => resolve(data.slidesId))
            .catch((err) => {

              if (err instanceof axios.Cancel) {

                return reject(new Error(slides.slidesUploadCancel))

              }
              reject(err)

            })

        }
        catch (e) {

          return reject(e)

        }

      }
      else {

        reject(new Error('failed to fetch the upload url'))

      }

    })

  },
  getApiVersion: async (presentation) => {

    let version
    const slidesDeckVersionUrl = `${presentation.dataLocation}player/version.json`

    try {

      const response: AxiosResponse<SlidesDeckVersion> = await axios.get(slidesDeckVersionUrl)
      version = response.data.version

    }
    catch (err) {

      version = '0.0.0'

    }

    return version

  }

}
